import { FC, useState } from "react";
import { Menu, Button, Text } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import ManageSignatures from '@/components/modals/jobcard/manage-signatures';

interface JobActionsProps {
  job: any;
  setJob: (job: any) => void;
  saveJob: () => Promise<boolean>;
  archiving: boolean;
  closing: boolean;
  archiveDisabled: boolean;
  closeDisabled: boolean;
  hasEmployee: boolean;
  accessStatus: any;
  editJobPermission: boolean;
  showFormsButton?: boolean;
  addRecurringJobPermission?: boolean;
  onArchive: () => void;
  onClose: () => void;
  onOpen: () => void;
  onCreateQuote?: () => void;
  onCreateInvoice?: () => void;
  onCreatePurchaseOrder?: () => void;
  onCreateRecurringJob?: () => void;
  moduleChangeCustomerPermission?: boolean;
  onChangeCustomer?: () => void;
  onShowForms?: () => void;
  onPrint?: () => void;
}

const JobActions: FC<JobActionsProps> = ({
  job,
  setJob,
  saveJob,
  archiving,
  closing,
  archiveDisabled,
  closeDisabled,
  hasEmployee,
  accessStatus,
  editJobPermission,
  showFormsButton = false,
  addRecurringJobPermission = false,
  onArchive,
  onClose,
  onOpen,
  onCreateQuote,
  onCreateInvoice,
  onCreatePurchaseOrder,
  onCreateRecurringJob,
  moduleChangeCustomerPermission = false,
  onChangeCustomer,
  onShowForms,
  onPrint,
}: any) => {
  const [showSignaturesModal, setShowSignaturesModal] = useState(false);

  return (
    <>
      <Menu shadow="md" width={240} position="bottom-end">
        <Menu.Target>
          <Button variant="blue" rightSection={<IconChevronDown size={16} />}>
            Actions
          </Button>
        </Menu.Target>

        <Menu.Dropdown>
          {onPrint && (
            <>
              <Menu.Item onClick={onPrint}>
                Print
              </Menu.Item>
              <Menu.Divider />
            </>
          )}

          {showFormsButton && (
            <Menu.Item onClick={onShowForms}>Forms</Menu.Item>
          )}

          {hasEmployee && (
            <Menu.Item
              onClick={() => setShowSignaturesModal(true)}
              disabled={!editJobPermission}
            >
              Signatures
            </Menu.Item>
          )}

          <Menu.Divider />

          <Menu.Label>Create</Menu.Label>
          <Menu.Item onClick={onCreateQuote}>Create Quote</Menu.Item>
          <Menu.Item onClick={onCreateInvoice}>Create Invoice</Menu.Item>
          <Menu.Item onClick={onCreatePurchaseOrder}>Create Purchase Order</Menu.Item>
          {addRecurringJobPermission && (
            <Menu.Item onClick={onCreateRecurringJob}>Create Recurring Job</Menu.Item>
          )}

          <Menu.Divider />

          <Menu.Label>Job Management</Menu.Label>
          {hasEmployee && (
            <>
              {moduleChangeCustomerPermission && (
                <Menu.Item onClick={onChangeCustomer}>
                  <Text size="sm">Change Customer</Text>
                </Menu.Item>
              )}
              <Menu.Item onClick={onArchive} disabled={archiveDisabled || archiving}>
                <Text size="sm">
                  {job.IsArchived
                    ? (archiving ? "Un-archiving..." : "Un-archive Job")
                    : (archiving ? "Archiving..." : "Archive Job")}
                </Text>
              </Menu.Item>
              <Menu.Item onClick={job.IsClosed ? onOpen : onClose} disabled={closeDisabled || closing}>
                <Text size="sm">
                  {job.IsClosed
                    ? (closing ? "Opening..." : "Open Job")
                    : (closing ? "Closing..." : "Close Job")}
                </Text>
              </Menu.Item>
            </>
          )}
        </Menu.Dropdown>
      </Menu>

      {showSignaturesModal && (
        <ManageSignatures
          job={job}
          setJob={setJob}
          saveJob={saveJob}
          setShowModal={setShowSignaturesModal}
          accessStatus={accessStatus}
        />
      )}
    </>
  );
};

export default JobActions;
